<template>
  <div class="breadcrumb">
    <ol>
      <!-- <li v-if="item.title" v-for="(item, index) in items" :key="index" :class="['small-title', item.isCurrent ? 'current' : '']">{{item.title | capitalizing}}</li> -->
    </ol>
  </div>
</template>

<script>

export default {
  name: 'adx-breadcrumb',
  components: {

  },
  props: {
    items: {
      required: false
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>